/** @jsx jsx */
import { jsx, Flex, Link } from "theme-ui";
import { Link as GatsbyLink } from "gatsby";
import { useCurrentSection } from "../utils/hooks";

const NavLink = ({href, gatsby, children}) => {
  const currentSection = useCurrentSection();

  const isActive = currentSection === "/" ?
    href === "/" :
    href.startsWith(currentSection);

  return gatsby ? (
    <GatsbyLink 
      to={href} 
      // activeClassName doesn't work here for the various blog sections,
      // and partiallyActive breaks Home.
      className={isActive ? "current" : ""}
      sx={{
        variant: "links.nav",
      }}
    >
      {children}
    </GatsbyLink>
  ) : (
    <Link href={href} variant="nav">
      {children}
    </Link>
  );
};

const Nav = ({ className }) => {
  return <Flex as="nav" className={className} sx={{
    flexWrap: "wrap",
    gap: [2, 4]
  }}>
    <NavLink href="/" gatsby>Home</NavLink>
    <NavLink href="/download/" gatsby>Download</NavLink>
    <NavLink href="/buy/" gatsby>Buy</NavLink>
    <NavLink href="/about/" gatsby>About</NavLink>
    <NavLink href="/faq/" gatsby>FAQ</NavLink>
    <NavLink href="/blog/articles/" gatsby>Blog</NavLink>
  </Flex>;
};

export default Nav;
